const mod = require('../../bahabot.module.js')


/**
 * @param {ActivityService} ActivityService
 * @param {ContextMenuService} ContextMenuService
 * @param {angular.IHttpService} $http 
 */
function bbActivityController(ActivityService, ContextMenuService, $http) {
    this.svc = ActivityService;
    ActivityService.get();

    this.clearFilter = (name) => {
        ActivityService.filters[name] = '';
    }

    this.computeTagBackground = (label) => {
        const preset = {
            'level': '#17ab0d',
            'streak': '#db8820',
            'tier': '#ae2ec5'
        };

        if (preset[label]) {
            return preset[label];
        }

        let hash = 0;
        for (let i = 0; i < label.length; i++) {
            hash = label.charCodeAt(i) + ((hash << 5) - hash);
        }

        const hue = hash % 180; // only allow half of hue space
        const saturation = 70 + (hash % 20); // 70-99%
        const lightness = 30 + (hash % 10);  // 30-39%

        return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    }

    this.openContextMenu = (ev, activity) => {
        const TYPE_REDEEM = 0,
              TYPE_BITS = 1,
              TYPE_SUBSCRIPTION = 2,
              TYPE_RAID = 3,
              TYPE_FOLLOW = 4;

        const typeToActions = {
            [TYPE_REDEEM]: [
                {key: 'copy', label: 'Copy Object'},
                {key: 'show_follow_button', label: 'Show Follow Button'},
                {key: 'rerun_commands', label: 'Rerun Commands'}
            ],
            [TYPE_BITS]: [
                {key: 'copy', label: 'Copy Object'},
                {key: 'show_follow_button', label: 'Show Follow Button'},
                {key: 'rerun_commands', label: 'Rerun Commands'}
            ],
            [TYPE_SUBSCRIPTION]: [
                {key: 'copy', label: 'Copy Object'},
                {key: 'show_follow_button', label: 'Show Follow Button'},
                {key: 'rerun_commands', label: 'Rerun Commands'}
            ],
            [TYPE_RAID]: [
                {key: 'copy', label: 'Copy Object'},
                {key: 'full_shoutout', label: 'Full Shoutout'},
                {key: 'show_follow_button', label: 'Show Follow Button'},
                {key: 'rerun_commands', label: 'Rerun Commands'}
            ],
            [TYPE_FOLLOW]: [
                {key: 'copy', label: 'Copy Object'},
                {key: 'show_follow_button', label: 'Show Follow Button'},
                {key: 'rerun_commands', label: 'Rerun Commands'}
            ]
        };

        ContextMenuService.open(ev, typeToActions[activity.type])
            .then((action) => {
                switch (action) {
                    case "copy": {
                        navigator.clipboard.writeText(JSON.stringify(angular.copy(activity)));
                        break;
                    }
                    default: {
                        const dto = {
                            action,
                            activityId: activity.id
                        }
                        $http({
                            method: 'POST',
                            url: '/api/protected/activities/action',
                            data: dto
                        }).then((v) => {
                            console.log(v);
                        })
                        break;
                    }
                }
            })
            .catch(() => {});
    }
}

mod.component('bbActivities', {
    templateUrl: 'tpl/bb-activities.component.html',
    bindings: {},
    controller: ["ActivityService", "ContextMenuService", "$http", bbActivityController]
});